export default __webpack_public_path__ + "static/12-654099715496b4d9da8ee4a6e585f395.jpg";